import React from "react";
import "./allpagination.scss"; // Import CSS for styling
import { IconPaginationLeft, IconPaginationRight } from "../../../icon/icons";

const AllPagination = ({ totalPages, currentPage, totalRecords, onPageChange, limit }) => {
  
  const handleNext = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handlePageSelect = (event) => {
    onPageChange(Number(event.target.value));
  };

  const startRecord = (currentPage - 1) * limit + 1;
  const endRecord = Math.min(currentPage * limit, totalRecords);

  const isStartEndSame = startRecord === endRecord;
  return (
    <div className="pagination-new">
      <div className="pagination-flex">
        {/* Display record range */}
        <div className="pagination-right">
          <div className="info">
            <p>
              {isStartEndSame ? <span>{startRecord}</span> : <span>{startRecord +' - '+endRecord}</span>} of {totalRecords}
            </p>
          </div>
        </div>

        {/* Pagination Controls */}
        <div className="pagination-left">
          <div className="controls">
            <span>The page you’re on</span>
            <div className="custom-select-wrapper">
              <select
                className="custom-select"
                value={currentPage}
                onChange={handlePageSelect}
              >
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <option key={page} value={page}>
                    {page}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="btn-data">
            <button onClick={handlePrev} disabled={currentPage === 1}>
              <IconPaginationLeft />
            </button>
            <button onClick={handleNext} disabled={currentPage === totalPages}>
              <IconPaginationRight />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllPagination;
